import { RoundedLeftArrow } from 'media/icons'
import { useQuery } from 'components/graphql'
import React from 'react'
import { StyledBranchHeaderAndWeather, StyledHeaderBack, StyledWeatherAndDate } from './styled'
import getWeatherInfo from 'pages/BranchDetails/gql/getWeatherInfo'
import { history } from 'config/history'
import { weatherIcons } from 'helpers/utils'
import DatePicker from 'components/DatePicker/DatePicker'

const WeatherAndDate = (props) => {
	const {
		title, geoData,
		formatedDate, shopId
	} = props
	const geoItem = geoData.find(item => item.id.split('-')[1] === shopId)
	const weatherResult = useQuery(getWeatherInfo, {
		skip: !geoItem?.coordinates,
		variables: {
			location: geoItem?.coordinates,
			startDate: formatedDate,
			include: []
		}
	})
	const { getWeatherInfo: weatherInfo } = weatherResult.data

	return (
		<StyledWeatherAndDate>
			<div className='header_branchinfo'>
				<StyledBranchHeaderAndWeather
					isTitleBig={title.length > 11}
				>
					<StyledHeaderBack onClick={history.goBack} className='backBtn'>
						<div className='back_btn'>
							<RoundedLeftArrow />
						</div>
					</StyledHeaderBack>
					<h3 className='title'>{title}</h3>
					{weatherInfo && (
						<div className='weather-info'>
							<i className={`wi wi-${weatherIcons[weatherInfo.days[0].icon]}`} />
							<p>{Math.round(weatherInfo.days[0].temp)}<span>&#176;</span></p>
						</div>
					)}
				</StyledBranchHeaderAndWeather>
			</div>
			<div className='header_item_date'>
				<DatePicker pickerType={'date'}/>
			</div>
		</StyledWeatherAndDate>
	)
}

export default WeatherAndDate
